import React, { useState } from "react";
import SelectBox from "../../commanComponents/selects/SelectBox";
import { InputBox } from "../../commanComponents/inputs/InputBox";
import "./workReport.css";
import { communication } from "../../constants/apis/communication";
import { useQuery } from "react-query";
import toast from "react-hot-toast";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import Loader from "../../commanComponents/Loader";

export default function WorkReport() {
  const pageLimit = process.env.REACT_APP_PUBLIC_LIMIT;
  const [gangs, setGangs] = useState([]);
  const [selectGang, setSelectGang] = useState(null);
  const [workReportData, setWorkReportDate] = useState([]);
  const [selectDepartment, setSelectDepartment] = useState(null);
  const [selectSection, setSelectSection] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const { isFetching } = useQuery(["getAllGandForDropdown"], () => communication?.getAllGandForDropdown(), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        const gangData = data?.data?.data?.map((ele) => {
          return { label: ele?.gangNo, value: ele?.gangNo };
        });
        setGangs(gangData);
      } else if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });
  const {
    data,
    refetch,
    isFetching: monthlyWorkReportLoading,
  } = useQuery(
    ["getMonthlyWorkReport"],
    () =>
      communication?.getMonthlyWorkReport({
        gangNo: selectGang?.value,
        startDate,
        endDate,
        section: selectSection?.value,
        department: selectDepartment?.value,
      }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data?.data?.status == "SUCCESS") {
          setWorkReportDate(data);
        } else if (data?.data?.status == "JWT_INVALID") {
          toast.error(`Failed: ${data?.data?.message}`);
        } else {
          setWorkReportDate([]);
        }
      },
      onError: (error) => {
        toast.error(`Failed: ${error?.message}`);
      },
    }
  );

  const handleReset = () => {
    setSelectGang(null);
    setSelectDepartment(null);
    setSelectSection(null);
    setStartDate("");
    setEndDate("");
    setWorkReportDate([]);
  };

  const today = new Date();

  const formatDate = (date) => date.toISOString().split("T")[0];

const getMaxEndDate = () => {
  if (!startDate) return "";

  const start = new Date(startDate);
  const startMonth = start.getMonth();
  const startYear = start.getFullYear();

  const endOfMonth = new Date(startYear, startMonth + 1, 0);

  const now = new Date();
  const todayMonth = now.getMonth();
  const todayYear = now.getFullYear();

  if (startMonth === todayMonth && startYear === todayYear) {
    return formatDate(now < endOfMonth ? now : endOfMonth);
  }

  // add 1 day safely
  const nextDay = new Date(endOfMonth);
  nextDay.setDate(endOfMonth.getDate() + 1);

  return formatDate(nextDay);
};


  const getMinEndDate = () => {
    return startDate || "";
  };

  const getList = () => {
    const jobs = workReportData?.data?.result?.[0]?.jobs;
    const jobMap = new Map();

    if (!Array.isArray(jobs)) return [];

    for (const job of jobs) {
      const { jobCode, amount, quantity } = job;

      if (jobMap.has(jobCode)) {
        const existing = jobMap.get(jobCode);
        existing.amount += amount;
        existing.quantity += quantity;
      } else {
        jobMap.set(jobCode, { ...job });
      }
    }

    const uniqueJobs = Array.from(jobMap.values());
    return uniqueJobs || [];
  };

  return (
    <>
      {monthlyWorkReportLoading && <Loader />}
      <div className="pageWrapper">
        <div className="workReportFilterWrapper">
          <SelectBox
            value={selectGang}
            label={"Gang*"}
            height={"30px"}
            style={{ width: "200px" }}
            isLoading={isFetching}
            onChange={(e) => {
              setSelectGang(e);
            }}
            options={gangs}
            placeholder={"Select Gang"}
          />
          <SelectBox
            value={selectDepartment}
            label={"Department"}
            style={{ width: "200px" }}
            height={"30px"}
            onChange={(e) => {
              setSelectDepartment(e);
            }}
            options={[
              { label: "UG", value: "ug" },
              { label: "OC", value: "oc" },
            ]}
            placeholder={"Select Department"}
          />
          <SelectBox
            value={selectSection}
            label={"Section"}
            height={"30px"}
            style={{ width: "180px" }}
            onChange={(e) => {
              setSelectSection(e);
            }}
            options={[
              { label: "UG", value: "ug" },
              { label: "OC", value: "oc" },
            ]}
            placeholder={"Select Section"}
          />
          <InputBox
            label="Start Date*"
            type="date"
            value={startDate}
            style={{ height: "38px", width: "150px" }}
            onChange={(e) => {
              const value = e.target.value;
              setStartDate(value);
              setEndDate("");
              // Clear end date if it violates new limits
              if (endDate && (endDate < value || endDate > getMaxEndDate())) {
                setEndDate(null);
              }
            }}
            placeholder="Select Start Date"
            max={formatDate(today)} // Don't allow future start dates
          />

          <InputBox
            label="End Date*"
            type="date"
            value={endDate}
            style={{ height: "38px", width: "150px" }}
            onChange={(e) => setEndDate(e.target.value)}
            min={getMinEndDate()}
            max={getMaxEndDate()}
            disabled={!startDate} // Disable until start date is selected
            placeholder="Select End Date"
          />
          <ColorBtn
            text={"Find"}
            bgColor={"#3b57e8"}
            color={"#fff"}
            padding="7px 10px"
            onClick={() => {
              if (startDate && endDate && selectGang) {
                refetch();
              } else {
                toast.error(`Gang No, Start date and End date is required!`);
              }
            }}
          />
          <ColorBtn text={"Reset"} bgColor={"transparent"} color={"black"} padding="7px 10px" onClick={handleReset} />
        </div>
        <div className="workReportWrapper comman-box-shadow">
          <table>
            <thead>
              <tr>
                <th className=" col_150px">Department</th>
                <th className=" col_150px">Section</th>
                <th className="col_150px">Gang</th>
                <th className="col_150px">Job Code</th>
                <th className="col_400px">Job Description</th>
                <th className="col_150px">Quantity</th>
                <th className="col_150px">Job Rate</th>
                <th className="col_150px">Unit</th>
                <th className="col_150px">Amount</th>
              </tr>
            </thead>
            <tbody>
              {getList()?.map((ele, index) => {
                return (
                  <tr>
                    <td className="text-capitalize">{index == 0 ? data?.data?.result?.[0]?.Department : ""}</td>
                    <td className="text-capitalize">{index == 0 ? data?.data?.result?.[0]?.Section : ""}</td>
                    <td className="text-capitalize">{index == 0 ? data?.data?.result?.[0]?.Gang : ""}</td>
                    <td className="text-capitalize">{ele?.jobCode || "--"}</td>
                    <td className="text-capitalize">{ele?.jobDescription || "--"}</td>
                    <td className="text-capitalize">{Number(ele?.quantity)?.toFixed(2) || "--"}</td>
                    <td className="text-capitalize">{Number(ele?.jobRate)?.toFixed(2) || "--"}</td>
                    <td className="text-capitalize">{ele?.unit || "--"}</td>
                    <td className="text-capitalize">{Number(ele?.amount)?.toFixed(2) || "--"}</td>
                  </tr>
                );
              })}

              {(workReportData?.data?.result || workReportData?.data?.data?.length) && (
                <tr className="bold-row">
                  <td colSpan="1"></td>
                  <td colSpan="1"></td>
                  <td colSpan="1"></td>
                  <td colSpan="5">Total Amount</td>
                  <td>{workReportData?.data?.result?.[0]?.totalAmount}</td>
                </tr>
              )}
              {(workReportData?.data?.result || workReportData?.data?.result?.length) && (
                <tr className="bold-row">
                  <td colSpan="1"></td>
                  <td colSpan="1"></td>
                  <td colSpan="1"></td>
                  <td colSpan="5">Total Gang Attendance</td>
                  <td>{workReportData?.data?.result?.[0]?.totalAttendance}</td>
                </tr>
              )}

              {(workReportData?.data?.result || workReportData?.data?.result?.length) && (
                <tr className="bold-row">
                  <td colSpan="1"></td>
                  <td colSpan="1"></td>
                  <td colSpan="1"></td>
                  <td colSpan="5" className="highlight-row">
                    Gang Average
                  </td>
                  <td className="highlight-row">{workReportData?.data?.result?.[0]?.gangAverage}</td>
                </tr>
              )}

              {(!workReportData?.data?.result || !workReportData?.data?.result?.length) && (
                <tr>
                  <td colSpan="9" className="text-center p-5">
                    Earning data not found !
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
